import { AttackPattern, PatternState } from '../../AttackPattern.js';

/**
 * Echo Lance — the ghost's hostile mirror of Spirit Lance (Echo Duel, see
 * data/echoBoss.js): locks the player's position during the telegraph, then
 * fires a staggered burst of fast bolts down that line. `config.level` is
 * the recorded weapon's level — the ghost fights as hard as you built it.
 */
export class EchoLance extends AttackPattern {
  constructor({ config }) {
    super({ name: 'Echo Lance', telegraphDuration: 0.9, activeDuration: 0.5, minPhase: 0 });
    this.config = config;
  }

  onBegin(boss, player) {
    this._aim = { x: player.x, y: player.y };
    this._fired = 0;
    this._fireTimer = 0;
  }

  onActiveTick(dt, boss, _player, pool) {
    this._fireTimer -= dt;
    const bolts = 2 + Math.ceil((this.config.level ?? 1) / 3); // 3 @ lvl1-3, 4 @ lvl4-6, 5 @ lvl7+
    if (this._fireTimer > 0 || this._fired >= bolts) return;
    this._fireTimer = 0.14;
    this._fired++;

    const angle = Math.atan2(this._aim.y - boss.y, this._aim.x - boss.x);
    const speed = this.config.speed + (this.config.level ?? 1) * 6;
    pool.fire({
      x: boss.x,
      y: boss.y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      radius: 3,
      damage: this.config.damage,
      color: '#7e97ff',
      lifetime: 3,
    });
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'lockOn', x: boss.x, y: boss.y, tx: this._aim.x, ty: this._aim.y };
  }
}
